import * as Sentry from '@sentry/react';
import { router } from '../router/router';

Sentry.init({
	dsn: import.meta.env.VITE_SENTRY_DSN,
	integrations: [
		// See docs for support of different versions of variation of react router
		// https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
		Sentry.tanstackRouterBrowserTracingIntegration(router),
		Sentry.captureConsoleIntegration({ levels: ['error'] }),
		Sentry.feedbackIntegration({
			colorScheme: 'light',
			autoInject: false,
			attachTo: document.getElementById('test'),
			showBranding: false,
			enableScreenshot: false, // Looks like screenshot is currently broken, so we disable it for now
			showName: false, // Name can currently not be autofilled, tried both name and fullName in the setUser but didn't get it to work
		}),
	],
	environment: APP_ENV,
	enabled: !!APP_ENV && APP_ENV !== 'development',

	// Set tracesSampleRate to 1.0 to capture 100%
	// of transactions for tracing.
	tracesSampleRate: 0.1,

	// Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
	tracePropagationTargets: [
		/^https:\/\/portal\.uturn-now\.com/,
		/^https:\/\/portal-staging\.uturn-now\.com/,
		/^https:\/\/.*\.uturn-vercel\.app/,
	],

	// Filter out third-party errors we cannot fix
	beforeSend(event, hint) {
		const error = hint.originalException;

		// Filter out PostHog session replay network errors
		// These occur when PostHog's recorder fails to capture network activity
		// due to ad blockers, network issues, or CORS problems
		if (
			error instanceof Error &&
			error.message === 'Failed to fetch' &&
			event.exception?.values?.[0]?.stacktrace?.frames?.some(
				(frame) =>
					frame.filename?.includes('posthog-recorder.js') ||
					frame.filename?.includes('ph.uturn-system.com'),
			)
		) {
			return null;
		}

		return event;
	},
});
